import styled from '@xstyled/emotion';
import { th } from '@xstyled/system';
import Picker from 'react-datepicker';
import { mixins } from '@oms/ui-utils';
import { clearButtonMixin } from '@oms/ui-icon-button';

export const DatePicker = styled(Picker)`
  /** We need wrap the the DatePicker in order to be able to style the clear button */
  & + .react-datepicker__close-icon {
    ${clearButtonMixin}
    ${th('iconButton.variants.secondary')}
  }
` as typeof Picker;

/**
 * There's a bit of style duplication in PopperContainer and CalendarContainer.
 * Try keeping them in sync.
 */
export const CalendarContainer = styled.div`
  width: 100%;
  ${th('dateInput.default')}

  &.react-datepicker {
    ${mixins.borderBox}
    ${th('panel')}
    box-shadow:none;
  }

  .react-datepicker__month-container {
    width: 100%;
  }

  .react-datepicker__header {
    border-bottom: sm;
    border-color: border;
    background-color: transparent;
  }

  .react-datepicker__header {
    border-bottom: sm;
    border-color: border;
    background-color: transparent;
    width: 100%;
  }

  .react-datepicker__navigation {
    top: 1rem;
    height: 1rem;
    width: 1rem;
  }
  .react-datepicker__navigation--previous {
    border-right-color: border;
  }
  .react-datepicker__navigation--next {
    border-left-color: border;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-size: md-mobile;
    color: text;
    font-weight: medium;
  }

  .react-datepicker__month-container {
  }

  .react-datepicker__day-name {
    text-transform: uppercase;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: text;
    font-size: md;
    display: inline-block;
    width: 1.75rem;
    line-height: 1.75rem;
    text-align: center;
    margin: 0.166rem 0.45rem;
  }
  .react-datepicker__day {
    ${th('dateInput.day.default')}
  }
  .react-datepicker__day--today {
    font-weight: medium;
    ${th('dateInput.day.today')}
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    ${th('dateInput.day.inRange')}
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--selected {
    ${th('dateInput.day.selected')}
  }

  .react-datepicker__day--range-end,
  .react-datepicker__day--range-start {
  }

  .react-datepicker__day--outside-month {
    color: text-placeholder;
  }

  .react-datepicker__day--outside-month {
    color: text-placeholder;
  }

  .react-datepicker__day--disabled,
  .react-datepicker__day--excluded {
    cursor: not-allowed;
    color: text-placeholder;
  }
`;

export const PopperContainer = styled.div`
  width: 100%;
  ${th('dateInput.default')}

  .react-datepicker {
    ${mixins.borderBox}
    ${mixins.panel}
    ${th('panel')}
  }

  .react-datepicker__header {
    border-bottom: sm;
    border-color: border;
    background-color: transparent;
  }

  .react-datepicker__navigation {
    top: 1rem;
    height: 1rem;
    width: 1rem;
  }
  .react-datepicker__navigation--previous {
    border-right-color: border;
  }
  .react-datepicker__navigation--next {
    border-left-color: border;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-size: md-mobile;
    color: text;
    font-weight: medium;
  }

  .react-datepicker__month-container {
  }

  .react-datepicker__day-name {
    text-transform: uppercase;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: text;
    font-size: md;
    display: inline-block;
    width: 1.75rem;
    line-height: 1.75rem;
    text-align: center;
    margin: 0.166rem 0.45rem;
  }
  .react-datepicker__day {
    ${th('dateInput.day.default')}
  }
  .react-datepicker__day--today {
    font-weight: medium;
    ${th('dateInput.day.today')}
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--selected {
    background-color: selected;
    color: inverse-text;
    ${th('dateInput.day.selected')}
  }
  .react-datepicker__day--in-selecting-range {
    ${th('dateInput.day.inRange')}
  }
  .react-datepicker__day--outside-month {
    color: text-placeholder;
  }

  .react-datepicker__day--outside-month {
    color: text-placeholder;
  }
`;
